"use strict";
exports.__esModule = true;
exports.PAYMENT_TYPE = exports.LOAN_PURPOSE = void 0;
/**
 * the values are not snakecase as per our convention as they're based on the Lixi Spec, which we are storing inside BaaS as is
 */
var LOAN_PURPOSE = {
    BUSINESS: 'Business',
    INVESTMENT_NONRESIDENTIAL: 'Investment Non Residential',
    INVESTMENT_RESIDENTIAL: 'Investment Residential',
    OWNER_OCCUPIED: 'Owner Occupied',
    PERSONAL: 'PERSONAL'
};
exports.LOAN_PURPOSE = LOAN_PURPOSE;
var PAYMENT_TYPE = {
    InterestCapitalised: 'Interest Capitalised',
    InterestOnly: 'Interest Only',
    InterestPartiallyCapitalised: 'Interest Partially Capitalised',
    PrepaidInterest: 'Prepaid Interest',
    PrincipalAndInterest: 'Principal and Interest',
    PrincipalInterestFees: 'Principal Interest Fees'
};
exports.PAYMENT_TYPE = PAYMENT_TYPE;
